export default __webpack_public_path__ + "static/media/UhDa_Studies.f56c53a0.png";